<script setup lang="ts">
  import { ref, computed } from "vue";

  const { url } = defineProps<{ url?: string }>();

  const visibleNotFoundImage = ref(false);

  const fullImageUrl = computed(() => {
    if (url.startsWith('/')) return url;
    return '//' + url;
  });
</script>

<template>
  <div class="image">
    <img v-if="!url || visibleNotFoundImage" :src="'/image2.png'" class="image__default" />
    <img v-else :src="fullImageUrl" @error="visibleNotFoundImage = true" />
  </div>
</template>

<style scoped>
  .image {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border-radius: 8px;
    background-color: var(--sf-base-background-secondary);
  }

  .image img {
    width: 80%;
  }

  .image img:not(.image__default) {
    width: 100%;
  }
</style>
